// extracted by mini-css-extract-plugin
export default {"container":"FilesModule_container__KAldF","docs":"FilesModule_docs__T23VB","scrollY":"FilesModule_scrollY__gJpQp","hideOverflow":"FilesModule_hideOverflow__0gm3z"};